module.exports = __webpack_public_path__ + "media/images/content_paper-38d7d17285f71a8fd1fa138643317387.svg";